import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import MaterialTable, { MTableAction, MTableActions, MTableBody, MTableHeader, MTableToolbar } from 'material-table';
import { IconButton, Tooltip } from '@material-ui/core';
import { History } from '@material-ui/icons';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import MTableFilterRow from '../../components/material-table-overrides/MTableFilterRow';
import KpiHistoryModal from './KpiHistoryModal';
import {
  renderNameTooltip,
  renderEditMoneyComponent,
  renderNamesString,
  isUserChargedForRow,
  renderNullStringValues,
  renderNullFloatValues,
  isRowVisibleForUser,
  getIsOpenPeriodsSelected,
  filterKpisByYear,
} from './Shared';

import { localization, modifyDefaultOptions } from '../../helpers/table';
import { getStickyColumns, FilterInput } from '../../helpers/table.jsx';
import { range, tableIcons } from '../../helpers';
import { getAllFacts, updateFactsRow } from '../../services/factsSvc';
import useUserContext from '../../hooks/useUserContext';
import useAPI from '../../hooks/useAPI';
import { isAdmin } from '../../services/rolesSvc';
import CustomTableActions from '../../components/table/CustomTableActions';
import LoadingTable from '../../components/table/LoadingTable';
import './PartFactBasic.less'
import { useHistory } from 'react-router-dom';
import settingsIcon from '../../../img/icons/icon-settings.svg'
import moment from 'moment';
import HideColumnButton from '../../components/UI/HideColumnButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CalcDescriptionModal from '../../components/Indexes/CalcDescriptionModal';

// TODO: remove hardcode
const DEFAULT_YEAR = 2025;
const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
const months = ['02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const currentMonth = '0' + (new Date().getMonth() + 1);

const passByYear = (val, years) => {
  if(years.length === 0) return true;
  const startDate = new Date(val.startDate);
  const endDate = new Date(val.endDate);
  const nowDate = new Date();
  startDate.setHours(0,0,0,0)
  endDate.setHours(0,0,0,0)
  nowDate.setHours(0,0,0,0)
  return years.length === 1 && years[0] === nowDate.getFullYear()
    ? (!val.startDate || startDate.getTime() <= nowDate.getTime()) &&
    (!val.endDate || endDate.getTime() >= nowDate.getTime())
    : (!val.startDate || years.some(year => startDate.getFullYear() <= year)) &&
    (!val.endDate || years.some(year => endDate.getFullYear() >= year));
}

export default function PartFactBasic() {
  const userCtx = useUserContext();
  const history = useHistory();

  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const MTableFiltersRef = useRef({});
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [periodsInfo, setPeriodsInfo] = useState([]);
  const [filterYears, setFilterYears] = useState([DEFAULT_YEAR]);
  const isOpenPeriodSelected = useMemo(() => getIsOpenPeriodsSelected(filterYears, periodsInfo), [filterYears, periodsInfo]);
  const [isAllMonths, setIsAllMonths] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [show, setShow] = useState(false);
  const [showIndexDescription, setShowIndexDescription] = useState(null);

  data.sort((a, b) => {
    const na = a.num.substr(1)
      .split('.');
    const nb = b.num.substr(1)
      .split('.');
    for (let nidx = 0; nidx < Math.min(na.length, nb.length); nidx++) {
      const cmp = Number(na[nidx]) - Number(nb[nidx]);
      if (cmp !== 0) return cmp;
    }
    return na.length - nb.length;
  });

  const api = useAPI();
  const [historyModalReport, setHistoryModalReport] = useState(null);

  async function load() {
    let result = await getAllFacts();

    result = result.filter((row) => isRowVisibleForUser(row, userCtx));
    setOriginalData(result);
  }

  useEffect(async () => {
    await load();

    const responsePeriods = await api.get('/reports/periods/kpi');
    if (responsePeriods && !responsePeriods.error) {
      setPeriodsInfo(responsePeriods);
      const currentPeriod = responsePeriods.find((p) => p.year === DEFAULT_YEAR);
      if (currentPeriod) setCurrentPeriod(currentPeriod);
    }
    setIsLoaded(true);
  }, []);

  useMemo(() => {
    setData(originalData.filter(val => passByYear(val, filterYears)));
  }, [originalData, filterYears]);

  const handleChange = (e) => {
    MTableFiltersRef.current = {};
    const yearValue = parseInt(e.target.value);
    const newFilterYears = filterYears.includes(yearValue)
      ? filterYears.filter((item) => item !== yearValue)
        .sort()
      : [...filterYears, yearValue].sort();
    setFilterYears(newFilterYears);
  };

  const togglePeriodClosed = async () => {
    const response = await api.post(`/reports/periods/kpi/${DEFAULT_YEAR}/close`, { close: !currentPeriod.isClosed });
    if (response && !response.error) setCurrentPeriod(response);
  };

  const isPeriodOpen = (year) => {
    const foundPeriod = periodsInfo.find((p) => p.year === year);
    return foundPeriod && !foundPeriod.isClosed;
  };
  const getColumns = () => {
    let colsLeft = [
      {
        title: '№',
        field: 'num',
        editable: 'never',
        filterCellStyle: { width: '60px' },
        width: '60px',
      },
      {
        title: 'Показатель',
        field: 'name',
        editable: 'never',
        render: rowData => <div>
          {rowData.name}
          <HelpOutlineIcon
            style={{ opacity: 0.66, fontSize: 16, marginLeft: 4, marginBottom: 2, cursor: 'pointer'}}
            onClick={() => setShowIndexDescription(rowData)}
          />
          <CalcDescriptionModal show={showIndexDescription?.id === rowData.id} onHide={() => setShowIndexDescription(null)} index={showIndexDescription}/>
        </div>,
        filterCellStyle: { minWidth: '270px' },
        width: '270px',
        filterComponent: ({
          columnDef,
          onFilterChanged
        }) => <FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="name"/>
      },
      {
        title: 'Единица',
        field: 'unit',
        editable: 'never',
        width: '80px',
        filterCellStyle: { minWidth: '80px' },
        filterComponent: ({
          columnDef,
          onFilterChanged
        }) => <FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="unit"/>
      },
    ];
    const colsRight = [
      {
        title: 'Представители ответственных',
        field: 'personsInCharge',
        editable: 'never',
        render: (rowData) => renderNamesString(rowData.personsInCharge),
        filterCellStyle: { minWidth: '300px' },
        filterComponent: ({
          columnDef,
          onFilterChanged
        }) => <FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="personsInCharge"/>
      },
    ];

    const byYearsColsFactory = (year) => {
      const result = [];
      if (year === 2022) {
        result.push({
          title: `Факт на конец полугодия ${year}`,
          field: `factHalf_${year}`,
          render: (rowData) => renderNullFloatValues(rowData[`factHalf_${year}`]),
          editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
          editComponent: renderEditMoneyComponent,
          filterCellStyle: { minWidth: '135px' },
        });
      }
      if (year >= 2023) {
        months.filter((e) => ['03', '04', '05', '06', '07'].includes(e) || isAllMonths)
          .forEach((m) => {
            result.push({
              title: `Факт на 01.${m}.${year}`,
              field: `fact${m}_${year}`,
              render: (rowData) => renderNullFloatValues(rowData[`fact${m}_${year}`]),
              editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
              editComponent: renderEditMoneyComponent,
              filterCellStyle: { minWidth: '135px' },
            });
          });
      }
      if (year >= 2022) {
        result.push({
          title: `Факт предварительного отчета ${year}`,
          field: `factSemi_${year}`,
          render: (rowData) => renderNullFloatValues(rowData[`factSemi_${year}`]),
          editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
          editComponent: renderEditMoneyComponent,
          filterCellStyle: { minWidth: '135px' },
        });
      }
      return result;
    };

    const colsMiddle = filterYears.reduce(
      (acc, year) => [
        ...acc,
        {
          title: `План по Программе ${year}`,
          field: `plan${year}`,
          editComponent: renderEditMoneyComponent,
          editable: () => isAdmin(userCtx) && isPeriodOpen(year),
          render: (rowData) => renderNullFloatValues(rowData[`plan${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `План максимум ${year}`,
          field: `planInner${year}`,
          editComponent: renderEditMoneyComponent,
          editable: () => isAdmin(userCtx) && isPeriodOpen(year),
          render: (rowData) => renderNullFloatValues(rowData[`planInner${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        ...byYearsColsFactory(year),
        {
          title: `Прогноз ${year}`,
          field: `estimate${year}`,
          editComponent: renderEditMoneyComponent,
          editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
          render: (rowData) => renderNullFloatValues(rowData[`estimate${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `Факт ${year}`,
          field: `fact${year}`,
          render: (rowData) => renderNullFloatValues(rowData[`fact${year}`]),
          editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
          editComponent: renderEditMoneyComponent,
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `Комментарий ${year}`,
          field: `comment${year}`,
          editable: (colProps, rowData) => isUserChargedForRow(rowData, userCtx) && isPeriodOpen(year),
          filterCellStyle: { minWidth: '150px' },
        },
        {
          title: `Ответственный ${year}`,
          field: `reportBosses${year}`,
          editable: 'never',
          render: (rowData) => renderNamesString(rowData[`reportBosses${year}`]),
          filterComponent: ({
            columnDef,
            onFilterChanged
          }) => <FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field={`reportBosses${year}`}/>
        },
      ],
      []
    );

    return [...getStickyColumns(colsLeft, '96px'), ...colsMiddle, ...colsRight];
  };

  const handleHideColumns = (columnName) => {
    const updatedHiddenColumns = hiddenColumns.includes(columnName) ? hiddenColumns.filter(value => value !== columnName) : ([...hiddenColumns, columnName])
    localStorage.setItem('hidden-fact-basic-cols', JSON.stringify(updatedHiddenColumns))
    setHiddenColumns(updatedHiddenColumns)
  }

  useEffect(() => {
    const defaultHiddenColumns = JSON.parse(localStorage.getItem('hidden-fact-basic-cols') || '[]')
    defaultHiddenColumns.push('Факт на 01.03.2024')
    setHiddenColumns(defaultHiddenColumns)
  }, []);

  return (
    <section className="partFactBasic">
      <div style={styledTable}>
        <MaterialTable
          components={{
            Body: (props) => {
              return <LoadingTable spinnerStyle={{ marginTop: '40px' }} loadingObject={{ isLoaded }}><CustomTableActions WrapperComponent={MTableBody} actionProps={props}/></LoadingTable>;
            },
            Header: (props) => {
              return <>{isLoaded && <CustomTableActions WrapperComponent={MTableHeader} actionProps={props}/>}</>;
            },
            Actions: (props) => {
              return <CustomTableActions WrapperComponent={MTableActions} actionProps={props}/>;
            },
            FilterRow: (props) => (<MTableFilterRow {...props} />),
            Toolbar: (props) => (
              <div className="partFactBasic-toolbar">
                <div className="partFactBasic-toolbarContainer">
                  <MTableToolbar {...props} />
                  <Button onClick={() => history.push('add/component')}>+ Добавить компонент</Button>
                </div>
                <div className="filters-container">
                  <div className="year-checkboxes">
                    {years.map((year, i) => (
                      <label key={year}>
                        <input
                          type="checkbox"
                          value={year}
                          onChange={handleChange}
                          checked={filterYears.includes(year)}
                        />
                        <span className="tag">{year}</span>
                      </label>
                    ))}
                  </div>
                  <div style={{ marginLeft: 'auto' }}>
                    <HideColumnButton
                      columns={props.columns.filter(column => !['num', 'name', 'unit'].includes(column.field))}
                      setHiddenColumns={handleHideColumns}
                      show={show}
                      setShow={setShow}
                    />
                  </div>
                </div>
                <div className="year-checkboxes">
                  {filterYears.filter((e) => e >= 2023).length > 0 &&
                    <label>
                      <input
                        type="checkbox"
                        checked={isAllMonths}
                        onChange={(e) =>
                          setIsAllMonths(e.target.checked)
                        }
                      />
                      <span className="tag">Отобразить все</span>
                    </label>
                  }
                </div>
              </div>
            ),
            Action: (props) => {
              if (!props.action.custom) {
                return <MTableAction {...props} />;
              }
              const action = typeof props.action === 'function' ? props.action(props.data) : props.action;
              return (
                <Tooltip title={action.tooltip}>
                  <IconButton onClick={() => action.onClick(props.data)} aria-label={action.tooltip} style={{ order: 2 }}>
                    <action.icon/>
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          options={modifyDefaultOptions({
            rowStyle: (rowData, index) => ({
              backgroundColor: index % 2 === 0 ? '#f5f5ff' : '#FFF',
            }),
            backgroundColor: '#FFF',
            maxBodyHeight: 'calc(100vh - 442px)',
            headerStyle: { height: 50 },
            filterCellStyle: {
              position: 'sticky',
              top: 64,
              background: 'white',
            },
          })}
          icons={tableIcons}
          localization={localization}
          columns={getColumns().map(column => ({...column, hidden: hiddenColumns.includes(column.title)}))}
          data={data}
          title="Данные для расчета фактических значений по показателям"
          editable={{
            isEditable: (rowData) => isUserChargedForRow(rowData, userCtx) && isOpenPeriodSelected && !rowData.formula,
            onRowUpdate: (newData) =>
              new Promise(async (resolve, reject) => {
                const yearsOpenedForUpdate = filterYears.filter((y) => isPeriodOpen(y));
                const updatedRow = await updateFactsRow(newData, yearsOpenedForUpdate);
                // await setOriginalData((prevState) =>
                //   prevState.map((e) =>
                //     e.id === newData.id ? { ...e, ...updatedRow } : e,
                //   ),
                // );
                await load();
                resolve();
              }),
          }}
          actions={[
            {
              custom: true,
              hidden: !isAdmin(userCtx),
              icon: () => <img src={settingsIcon}/>,
              tooltip: 'Редактировать компонент',
              onClick: (data) => {
                  history.push(`add/component/${data.id}`)
              }
            },
            {
              custom: true,
              hidden: false,
              icon: () => <History style={{ color: '#0D6EFD' }}/>,
              tooltip: 'История изменений',
              onClick: (data) => {
                setHistoryModalReport({
                  id: data.id,
                  num: data.num,
                  name: data.name
                });
              },
            },
          ].filter(value => !value.hidden)}
        />
      </div>
      {historyModalReport && <KpiHistoryModal report={historyModalReport} onClose={() => setHistoryModalReport(null)}/>}
    </section>
  );
}

const styledTable = {
  maxWidth: '100%',
  marginTop: 32,
};
